var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._t("default",function(){return [_vm._v(" ... ")]},{"isin":_vm.isin,"instrumentName":_vm.name})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }